<template>
  <div id="chatter-sidebar">
    <div>
      <img class="topbar-logo"
           src="../../assets/logo_ey.png" alt="EY Logo"/>
    </div>
    <sidebar-menu :menu="menu"
                  theme="black-theme"
                  width="auto"
                  :showOneChild="true"
                  :hide-toggle="true"
                  @item-click="onMenuClick"/>
  </div>
</template>

<script>
export default {
  name: 'ChatterSidebar',
  created() {
    if(this.currentUser.caller == 'member@abcmart.com') {
      this.menu = [
        {
          header: false,
          hiddenOnCollapse: true,
        },
        {
          title: "회원 관리",
          icon: "menu-icon chatter-dashboard",
          href: "/chatter/member-management",
        },
        {
          title: "포인트 관리",
          icon: "menu-icon chatter-dashboard",
          href: "/chatter/point-management"
        },
        {
          title: "쿠폰 관리",
          icon: "menu-icon chatter-dashboard",
          href: "/chatter/coupon-management"
        },
        {
          title: "회원 등급 관리",
          icon: "menu-icon chatter-dashboard",
          href: "/chatter/grade-management"
        },
        {
          title: "스탬프 관리",
          icon: "menu-icon chatter-dashboard",
          href: "/chatter/stamp-management",
        }
      ]
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
  },
  data() {
    return {
      menu: [
        {
          header: false,
          hiddenOnCollapse: true,
        },
        // { * 멤버별 Work Hours
        //   title: "Dashboard", 
        //   href: "/chatter/chatter-dashboard",
        //   icon: "menu-icon chatter-dashboard"
        // },
        // { * 기존 신세계용 ProjectDashboard
        //   title: "Project Dashboard",
        //   href: "/chatter/project-dashboard",
        //   icon: "menu-icon project-dashboard"
        // },
        {
          title: "Dashboard",
          // href: "/chatter/dashboard",
          path: "/chatter/dashboard",
          icon: "menu-icon chatter-dashboard"
        },
        // {
        //   title: "Project Dashboard3",
        //   href: "/chatter/project-dashboard3",
        //   icon: "menu-icon chatter-dashboard"
        // },
        {
          title: "Project List",
          // href: "/chatter/chatter-project-list",
          path: "/chatter/chatter-project-list",
          icon: "menu-icon project-list"
        },
        // {
        //   title: "Requirement List",
        //   // href: "/chatter/requirement-list",
        //   path: "/chatter/requirement-list",
        //   icon: "menu-icon project-list"
        // },
        //23.09.12 Chatter -> MeMO 
        {
          title: "MeMO List",
          // href: "/chatter",
          path: "/chatter",
          icon: "menu-icon chatter-list"
        },
        // {
        //   title: "WBS",
        //   // href: "/chatter/wbs",
        //   path: "/chatter/wbs",
        //   icon: "menu-icon chatter-list"
        // },
        /* 24-02-23 yhkim@hiaas.co.kr 
           Todo List의 기능이 완성되기 전까지 숨김 처리
        */
        // {
        //   title: "My ToDo List",
        //   href: "/chatter/my-schedule",
        //   icon: "menu-icon calendar"
        // },
        // 2024.03.22 Han : Code Snippet 과 Files 도 사용하지 않기 때문에 숨김
        // {
        //   title: "Code Snippet",
        //   href: "/chatter/code/snippets",
        //   icon: "menu-icon code"
        // },
        // {
        //   title: "Files",
        //   href: "/chatter/files",
        //   icon: "menu-icon code"
        // },
        {
          title: "Calendar",
          icon: "menu-icon calendar",
          // href: "/chatter/chatter-main-calendar",
          path: "/chatter/chatter-main-calendar",
          // child: [
          //   {
          //     title: "Holiday",
          //     href: "/chatter/chatter-holiday"
          //   },
          //   {
          //     title: "Day Off",
          //     href: "/chatter/chatter-day-off"
          //   },
          // ]
        },
        // {
        //   title: "Dashboard (PoC)",
        //   icon: "menu-icon chatter-dashboard",
        //   // href: "/chatter/poc",
        //   path: "/chatter/poc",
        // },
      ],
    }
  },
  methods: {
    onMenuClick(event, menuItem) {
      const path = menuItem.path;

      switch (path) {
        case '/chatter':
          // 상태 대시보드 필터 리셋
          this.$store.commit('chatter/resetStatusDashboardFilter');
          
          // 메모목록 필터 리셋
          this.$store.commit('chatter/resetFilter');

          // 필터링 옵션 레이블 리셋
          this.$store.commit('chatter/setSearchOptionsLabel', '');
      
          // 필터 사용여부 리셋
          this.$store.commit('chatter/setOccupied', false);
          this.$store.commit('chatter/setFilterOccupied', false);

          // ChatterFilter 초기화,
          // StatusDashboard를 구하는 로직 실행
          this.$store.commit('chatter/chatterListRefresh');

          this.$store.dispatch("chatter/reloadChats");
          break;
       
        case '/chatter/requirement-list':
          this.$store.commit('requirement/resetFilterFields', ['type', 'projectId']);
          this.$store.commit('requirement/withClosedProjects', false);
          break;
        
        case '/chatter/wbs':
          this.$store.commit('wbs/setProjectId', '');
          this.$store.commit('wbs/resetExpanded');
          this.$store.commit('wbs/resetFilter');
          this.$store.commit('wbs/setFilterExpanded', true);
          break;
      
        default:
          break;
      }
      if(this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
}
</script>
<style scoped>
#chatter-sidebar {
    padding: 7.291vw 1.041vw 5.208vw;
}

#chatter-sidebar >>> .v-sidebar-menu {
    position: relative;
    background-color: #2E2E38;
    margin-top: 2.604vw;
}

#chatter-sidebar >>> .topbar-logo {
    width: 100%;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--list {
    display: flex;
    flex-direction: column;
    gap: 0.933rem 0;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link {
    padding: 0.937vw 1.041vw;
    border-radius: 8px;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_hover,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link:hover {
    background: rgba(255, 255, 255, 0.10);
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active {
    box-shadow: none;
    background: rgba(255, 255, 255, 0.10);
}

#chatter-sidebar >>> .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    color: #FFE600;
    background: rgba(255, 255, 255, 0.10);
    border-radius: 8px 8px 0 0;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--title {
    width: calc(100% - (20px + 0.833vw));
    color: rgba(255, 255, 255, 0.70);
    font-family: NanumGothic;
    font-size: 16px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--title,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--title,
#chatter-sidebar >>> .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--title {
    color: #FFE600;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--icon.sidebar-icon {
    width: 20px;
    height: 20px;
    background-color: transparent;
    background-size: cover;
    background-repeat: no-repeat;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1 .vsm--icon.menu-icon {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 0.833vw;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1 .vsm--icon.menu-icon.chatter-dashboard {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.5 16.6667H2.5V4.16667" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5 5.83333L10.8333 11.6667L7.5 8.33333L2.5 12.5" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1 .vsm--icon.menu-icon.project-dashboard {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 9.16666H3.33333C2.8731 9.16666 2.5 9.53975 2.5 9.99999V16.6667H7.5V9.16666Z" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.6667 6.66666H12.5V16.6667H17.5V7.49999C17.5 7.03975 17.1269 6.66666 16.6667 6.66666Z" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.6667 3.33334H8.33333C7.8731 3.33334 7.5 3.70644 7.5 4.16668V16.6667H12.5V4.16668C12.5 3.70644 12.1269 3.33334 11.6667 3.33334Z" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1 .vsm--icon.menu-icon.project-list {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.8333 7.50001V4.16668C15.8333 3.70644 15.4602 3.33334 15 3.33334H3.33333C2.8731 3.33334 2.5 3.70644 2.5 4.16668V15.8333C2.5 16.2936 2.8731 16.6667 3.33333 16.6667H9.16667" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.5 13.3333H17.5" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.16667 12.5H2.5" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 15.8333L15 10.8333" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.1665 3.33334V16.6667" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8333 7.5L2.5 7.5" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1 .vsm--icon.menu-icon.chatter-list {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.5 8.33334L17.5 6.66668C17.5 6.20644 17.1269 5.83334 16.6667 5.83334L3.33333 5.83334C2.8731 5.83334 2.5 6.20644 2.5 6.66668L2.5 10C2.5 10.4602 2.8731 10.8333 3.33334 10.8333L9.16667 10.8333" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.6665 13.3333L16.6665 13.3333" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.1665 15.8333L14.1665 10.8333" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1 .vsm--icon.menu-icon.code {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.64307 12.3573L12.3571 7.64325" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.87504 9.41083L4.69653 10.5893C3.39478 11.8911 3.39478 14.0016 4.69653 15.3034C5.99827 16.6051 8.10882 16.6051 9.41057 15.3034L10.5891 14.1249" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.41064 5.8751L10.5892 4.69659C11.8909 3.39484 14.0015 3.39484 15.3032 4.69659C16.6049 5.99833 16.6049 8.10888 15.3032 9.41063L14.1247 10.5891" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1 .vsm--icon.menu-icon.calendar {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.3335 6.66669H16.6668" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8335 3.33331H4.16683C3.70659 3.33331 3.3335 3.70641 3.3335 4.16665V15.8333C3.3335 16.2935 3.70659 16.6666 4.16683 16.6666H15.8335C16.2937 16.6666 16.6668 16.2935 16.6668 15.8333V4.16665C16.6668 3.70641 16.2937 3.33331 15.8335 3.33331Z" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.3335 1.66669V3.33335" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.6665 1.66669V3.33335" stroke="%23C0C0C3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-color: transparent;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--icon.menu-icon.chatter-dashboard,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--icon.menu-icon.chatter-dashboard {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.5 16.6667H2.5V4.16667" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5 5.83333L10.8333 11.6667L7.5 8.33333L2.5 12.5" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--icon.menu-icon.project-dashboard,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--icon.menu-icon.project-dashboard {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 9.16666H3.33333C2.8731 9.16666 2.5 9.53975 2.5 9.99999V16.6667H7.5V9.16666Z" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.6667 6.66666H12.5V16.6667H17.5V7.49999C17.5 7.03975 17.1269 6.66666 16.6667 6.66666Z" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.6667 3.33334H8.33333C7.8731 3.33334 7.5 3.70644 7.5 4.16668V16.6667H12.5V4.16668C12.5 3.70644 12.1269 3.33334 11.6667 3.33334Z" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--icon.menu-icon.project-list,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--icon.menu-icon.project-list {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.8333 7.50001V4.16668C15.8333 3.70644 15.4602 3.33334 15 3.33334H3.33333C2.8731 3.33334 2.5 3.70644 2.5 4.16668V15.8333C2.5 16.2936 2.8731 16.6667 3.33333 16.6667H9.16667" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.5 13.3333H17.5" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.16667 12.5H2.5" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 15.8333L15 10.8333" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.1665 3.33334V16.6667" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8333 7.5L2.5 7.5" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--icon.menu-icon.chatter-list,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--icon.menu-icon.chatter-list {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M17.5 8.33334L17.5 6.66668C17.5 6.20644 17.1269 5.83334 16.6667 5.83334L3.33333 5.83334C2.8731 5.83334 2.5 6.20644 2.5 6.66668L2.5 10C2.5 10.4602 2.8731 10.8333 3.33334 10.8333L9.16667 10.8333" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.6665 13.3333L16.6665 13.3333" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.1665 15.8333L14.1665 10.8333" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active .vsm--icon.menu-icon.code,
#chatter-sidebar >>> .v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--icon.menu-icon.code {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.64307 12.3573L12.3571 7.64325" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.87504 9.41083L4.69653 10.5893C3.39478 11.8911 3.39478 14.0016 4.69653 15.3034C5.99827 16.6051 8.10882 16.6051 9.41057 15.3034L10.5891 14.1249" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.41064 5.8751L10.5892 4.69659C11.8909 3.39484 14.0015 3.39484 15.3032 4.69659C16.6049 5.99833 16.6049 8.10888 15.3032 9.41063L14.1247 10.5891" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon.menu-icon.calendar,
#chatter-sidebar >>> .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon.menu-icon.calendar {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.3335 6.66669H16.6668" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8335 3.33331H4.16683C3.70659 3.33331 3.3335 3.70641 3.3335 4.16665V15.8333C3.3335 16.2935 3.70659 16.6666 4.16683 16.6666H15.8335C16.2937 16.6666 16.6668 16.2935 16.6668 15.8333V4.16665C16.6668 3.70641 16.2937 3.33331 15.8335 3.33331Z" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.3335 1.66669V3.33335" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.6665 1.66669V3.33335" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--dropdown > .vsm--list {
    position: relative;
    gap: 0.533rem 0;
    padding: 0 0 0.933rem 3.541vw;
    background: rgba(255, 255, 255, 0.10);
    border-radius: 0 0 8px 8px;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--dropdown > .vsm--list::after {
    content: '';
    display: block;
    position: absolute;
    width: 2px;
    height: calc(100% - 0.933rem);
    border-radius: 30px;
    background-color: #747480;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--dropdown .vsm--title {
    font-size: 16px;
    font-weight: 500;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--dropdown .vsm--link {
    padding: 0.666rem;
    margin: 0 0.533rem;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--arrow {
    width: 20px;
    height: 20px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.833 7.5L9.99967 13.3333L4.16634 7.5" stroke="%23C0C0C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--arrow::after {
    content: none;
}

#chatter-sidebar >>> .v-sidebar-menu .vsm--arrow_open {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 12.5L10.0007 6.66667L4.16732 12.5" stroke="%23FFE600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
    transform: none;
}
</style>